export default __webpack_public_path__ + "static/media/facebook.242ee036.svg";